import React from 'react';
import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Card } from './Card';
import { Text } from './Text';

export const ErrorBox = ({ children }: PropsWithChildren) => {
    return (
        <StyledErrorBox>
            <Text $themeColor="negative">{children}</Text>
        </StyledErrorBox>
    );
};

const StyledErrorBox = styled(Card)`
    background-color: ${({ theme }) => theme.container.errorBackground};
    border: 0;
`;

export default ErrorBox;
